<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-09-07 17:18:21
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-22 17:02:31
-->
<template>
	<div class="flex-row-align-center">
		<div class="yx-color-text-primary">{{ cellValue.toString() }}</div>
		<div class="role-label ml-10" style="display: inline-block" v-if="row.parentId === '0'">公司</div>
	</div>
</template>

<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	name: 'LabelCell',
	mixins: [mixin],
	data() {
		return {};
	},
	computed: {
		roleList() {
			if (this.row.role && this.row.role.length) {
				return this.row.role;
			} else {
				return [];
			}
		},
	},
	props: {},
	components: {},

	mounted() {},

	methods: {},
};
</script>
<style lang="less" scoped></style>
